/* GZ 2026-10-13: auto-apply SUB20 on checkout (once-per-customer code can't be an automatic discount).
   If the cart has no applicable code, send checkout through /discount/SUB20?redirect=/checkout.
   SUB20 combinesWith = none, so it never stacks with other codes / the BOGO automatic. */
(function () {
  var CODE = 'SUB20';
  var busy = false;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href="/checkout"], #checkout');
    if (!btn || btn.disabled || busy) return;
    e.preventDefault(); e.stopPropagation();
    busy = true;
    var go = function (url) { window.location.href = url; };
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
        if (codes.length) go('/checkout');
        else go('/discount/' + CODE + '?redirect=%2Fcheckout');
      })
      .catch(function () { go('/discount/' + CODE + '?redirect=%2Fcheckout'); });
    setTimeout(function () { busy = false; }, 4000);
  }, true);
})();
